import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { cambiarStatusOrden } from '../../../../actions/ordenesSalida';

const CancelarOrdenModal = ({ show, onHide, idOrden, onSuccess }) => {
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const onConfirm = async () => {
        if (!idOrden) {
            onHide();
            return;
        }

        setSaving(true);
        const ok = await dispatch(cambiarStatusOrden(idOrden, 3));
        setSaving(false);

        if (!ok) return;

        onHide();
        if (typeof onSuccess === 'function') onSuccess();
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Cancelar orden de salida</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="alert alert-warning m-0">
                    ¿Estás seguro que deseas cancelar esta orden de salida?
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onHide}
                    disabled={saving}
                >
                    Cerrar
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={onConfirm}
                    disabled={saving}
                >
                    Cancelar orden
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelarOrdenModal;
